import { Flex, Icon, Text } from '@chakra-ui/react'
import React from 'react'

import { useEmptyStateStyle } from './componentStyles/EmptyState.style'

interface EmptyStateProps {
  icon: SVGComponent
  primaryText: string
  secondaryText: string
}
export const EmptyState = ({
  icon,
  primaryText,
  secondaryText,
}: EmptyStateProps) => {
  const styles = useEmptyStateStyle()
  return (
    <Flex sx={styles.container}>
      <Icon as={icon} sx={styles.icon} />
      <Flex sx={styles.textContainer}>
        <Text sx={styles.primaryText}>{primaryText}</Text>
        <Text sx={styles.secondaryText}>{secondaryText}</Text>
      </Flex>
    </Flex>
  )
}
